import React, { Component } from 'react';
import { connect } from 'react-redux'
import {Navbar, Nav } from 'react-bootstrap'
import { getEvents } from '../actions/eventActions'

// import { SERVER_URL } from '../config';
class Menu extends Component {
  render() {
    return (
    <Navbar bg="light" expand="lg">
      <Navbar.Brand href="#home">
      <img
        alt=""
        src="/bos_logo.png"
        width="30"
        height="30"
        className="d-inline-block align-top"
      />
      Kneskjælven
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link target="_blank" href="https://brikkesys.no/result.php?id=6425">Resultater</Nav.Link>
          <Nav.Link target="_blank" href="https://www.livelox.com/Events/Show/172623/Kneskj-lven-2025">Livelox</Nav.Link>
          <Nav.Link target="_blank" href="https://bos.idrett.no/next/p/64273/kneskjaelven">Hjemmeside</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
    )
  }
}
const mapStateToProps = (state) => ({
  ui: state.ui
  // , event: state.events.event
})

export default connect(mapStateToProps, { getEvents })( Menu ) ; 
